module.exports = __webpack_public_path__ + "img/slide-img-placeholder.a177f1a1.png";